<template>
    <GridDisplay title="Artistas" :method="setArtist" :posts="artists"/>
    <GridDisplay title="Canciones" :method="setSong" :posts="tracks"/>
</template>

<script>
    import GridDisplay from '@/components/GridDisplay.vue'
    export default {
      name: 'ResultsView',
      components:{
        GridDisplay
      },
      props:{
        artists: Array,
        tracks: Array
      },
      methods: {
        setSong(song){
            const url = this.baseUrl + '/track/'+song.id
            fetch(url)
                .then(response=>response.json())
                .then(json=> localStorage.setItem('currentSong', JSON.stringify(json)));
        },
        setArtist(a){
            if(typeof a !== 'undefined'){
                const tracklistUrl = a.tracklist.slice(22)
                fetch(this.baseUrl + tracklistUrl)
                .then(response=>response.json())
                .then(json=> localStorage.setItem('currentSong', JSON.stringify(json.data[0])));
            }  
        },
        }
    }
</script>